import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export default function ContactPage() {
  useDocumentTitle('Contact Us');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <header className="border-b border-slate-100">
        <div className="mx-auto max-w-4xl px-6 py-5 flex items-center justify-between">
          <Link to="/">
            <img src={logo} alt="LocalContact" className="h-7 w-auto object-contain" />
          </Link>
          <Link to="/" className="text-[13px] font-bold text-slate-600 hover:text-slate-900 transition-colors">
            Back to home
          </Link>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-6 py-16 pb-24">
        <div className="mb-12">
          <p className="text-[11px] font-black uppercase tracking-[0.18em] text-brand-700 mb-3">Get in touch</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-[-0.035em] text-slate-900 mb-4">Contact Us</h1>
          <p className="text-[15px] text-slate-500 leading-relaxed max-w-xl">
            Have a question, issue, or refund request? Reach out to our support team and we'll respond within 2 business days.
          </p>
        </div>

        {/* Support contact */}
        <div className="rounded-2xl border border-slate-100 bg-slate-50 p-7 mb-10">
          <h2 className="text-[13px] font-black uppercase tracking-[0.14em] text-slate-400 mb-5">Support</h2>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <div className="w-9 h-9 rounded-xl bg-white border border-slate-200 flex items-center justify-center shrink-0">
                <svg className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <div>
                <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">Email</p>
                <a href="mailto:support@localcontact.ai" className="text-[15px] font-semibold text-slate-900 hover:text-brand-700 transition-colors">
                  support@localcontact.ai
                </a>
                <p className="text-[13px] text-slate-400 mt-0.5">Response within 2 business days</p>
              </div>
            </div>
          </div>
        </div>

        {/* Legal / company info */}
        <div className="rounded-2xl border border-slate-100 bg-slate-50 p-7 mb-10">
          <h2 className="text-[13px] font-black uppercase tracking-[0.14em] text-slate-400 mb-5">Company Information</h2>
          <div className="space-y-5 text-[15px] text-slate-700 leading-relaxed">
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">Legal Name</p>
              <p className="font-semibold text-slate-900">ADNAN MANNA DIGITAL (OPC) PRIVATE LIMITED</p>
            </div>
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">CIN</p>
              <p className="font-mono text-slate-700">U62099KA2024OPC189911</p>
            </div>
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">Registered Address</p>
              <p className="text-slate-700">
                H No 4-97/B(10), Flat No 110-B, Floor No 1,<br />
                City Green View Apartments, Kunjibettu,<br />
                Udupi, Karnataka, India — 576102
              </p>
            </div>
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">Director</p>
              <p className="text-slate-700">Adnan Thajammul Hussain Manna</p>
              <p className="text-[13px] text-slate-400">DIN: 10675496</p>
            </div>
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">Contact Mobile</p>
              <a href="tel:+919844190125" className="text-slate-700 hover:text-brand-700 transition-colors">
                +91 98441 90125
              </a>
            </div>
            <div>
              <p className="text-[12px] font-bold text-slate-400 uppercase tracking-wider mb-1">Contact Email</p>
              <a href="mailto:athm793@gmail.com" className="text-slate-700 hover:text-brand-700 transition-colors">
                athm793@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Quick links */}
        <div className="mt-16 pt-8 border-t border-slate-100 flex flex-wrap gap-4 text-[13px] text-slate-400">
          <Link to="/refund" className="hover:text-slate-700 transition-colors font-medium">Refund Policy</Link>
          <span>·</span>
          <Link to="/terms" className="hover:text-slate-700 transition-colors font-medium">Terms of Service</Link>
          <span>·</span>
          <Link to="/privacy" className="hover:text-slate-700 transition-colors font-medium">Privacy Policy</Link>
          <span>·</span>
          <Link to="/" className="hover:text-slate-700 transition-colors font-medium">Back to home</Link>
        </div>
      </div>
    </div>
  );
}
